
import { WorkItemTypesFilter } from "Analytics/Scripts/Controls/ConfigUIContracts";

/**
 * The {WitPicker} component will insert a property of this type into the config.
 */
export type WitPickerConfigProperty = WorkItemTypesFilter[];